import {
  useState,
  useEffect,
  useReducer,
  useRef,
  useContext,
  useCallback,
} from 'react';
import axios from 'axios';

import { getReducer } from '../../../utils';
import Banner from './compoments/Banner';
import Brochure from './compoments/Brochure';
import Statistics from './compoments/Statistics';
import OurServices from './compoments/OurServices';
import OurPartners from './compoments/OurPartners';
import NewsEvents from './compoments/NewsEvents';
import Feedback from './compoments/Feedback';
import LoadingBox from '../../compoment/LoadingBox';
import MessageBox from '../../compoment/MessageBox';
import EnrollmentForm from '../enrollment/EnrollmentForm';
import ModalEnrollment from '../enrollment/ModalEnrollment';
import useIsDevice from '../../../format/useIsDevice';
import { Store } from '../../../Store';
import Testimonials from './compoments/Testimonials';
import { useSeoHomePage } from '../../../seo/UseSeoPage';
import LatestNews from './compoments/LatestNews';

const initialState = {
  news: [],
  banners: [],
  video: null,
  shareStudent: null,
  activity: null,
  feedback: null,
  partner: null,
  loading: true,
  error: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, ...action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const Main = () => {
  const [modalShow, setModalShow] = useState(false);
  const hasFetchedRef = useRef(false);
  const isTablet = useIsDevice(576, 991);
  const limitPost =  5;

  const [state, dispatch] = useReducer(getReducer(reducer), initialState);

  const { dispatch: ctxDispatch } = useContext(Store);

  const fetchPageSections = async () => {
    const {
      data: { data: sections },
    } = await axios.get('/page-section/public/shows?pageSlug=trang-chu');

    const extractContent = (type) =>
      sections
        .filter((item) => item.sectionType === type)
        .flatMap((item) => item.content);

    return {
      banners: extractContent('banner'),
      video: extractContent('video'),
      number: extractContent('number'),
      shareStudent: extractContent('shareStudent'),
      activity: extractContent('activity'),
      feedback: extractContent('feedback'),
      partner: extractContent('partner'),
    };
  };

  const fetchPosts = async () => {
    const {
      data: {
        data: { posts },
      },
    } = await axios.get('/post/public/shows');

    const extractPosts = () => ({
      data: posts
        .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))
        .slice(0, 5),
    });

    return [extractPosts()];
  };

  const fetchData = useCallback(async () => {
    dispatch({ type: 'FETCH_REQUEST' });
    try {
      const [sectionsData, postsData] = await Promise.all([
        fetchPageSections(),
        fetchPosts(),
      ]);

      dispatch({
        type: 'FETCH_SUCCESS',
        payload: { ...sectionsData, news: postsData },
      });
    } catch (err) {
      dispatch({ type: 'FETCH_FAIL', payload: err.message });
    }
  }, [dispatch]);

  const fetchTotalSearch = useCallback(() => {
    ctxDispatch({
      type: 'SET_TOTALSEARCH',
      payload: 0,
    });
    localStorage.setItem('totalSearch', JSON.stringify(0));
  }, [ctxDispatch]);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    fetchData();
    fetchTotalSearch();
    const timer = setTimeout(() => setModalShow(true), 10000);
    return () => clearTimeout(timer);
  }, [fetchData, fetchTotalSearch]);

  useSeoHomePage();

  const {
    loading,
    error,
    banners,
    video,
    shareStudent,
    number,
    activity,
    news,
    feedback,
    partner,
  } = state;

  if (loading) return <LoadingBox />;
  if (error) return <MessageBox variant="danger">{error}</MessageBox>;

  return (
    <div>
      <Banner data={banners} />
      {/* <Brochure data={video?.[0]} /> */}
      <LatestNews data={news?.[0]?.data?.[0]} />

      <NewsEvents
        data={news.map((item) => ({
          ...item,
          data: item.data.slice(1, limitPost),
        }))}
      />
      <Statistics data={number} />
      <Testimonials data={shareStudent} />
      <OurServices data={activity} />
     
      <Feedback data={feedback} />
      <OurPartners data={partner} />
      <EnrollmentForm />
      <ModalEnrollment show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
};

export default Main;
